"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVariantRegions = void 0;
const getVariantRegions = (variant) => {
    if (!variant)
        return [];
    if (!variant.order_lines)
        return [];
    let regions = variant.order_lines.map((orderLine) => {
        return orderLine.region_name?.en;
    });
    regions = Array.from(new Set(regions));
    return regions;
};
exports.getVariantRegions = getVariantRegions;
